<template>
  <v-container class="main-container">
    <v-row>
      <v-col xs="12" md="8" offset-md="2">
        <p class="headline">{{ $t("landing.welcome.head") }}</p>
        <p class="body-1">{{ $t("landing.welcome.subhead") }}</p>
        <!-- <v-btn class="ma-2 nobtn" outlined color="indigo"><v-icon>mdi-google-chrome</v-icon> Chrome Extension Coming Soon</v-btn> -->
        <v-btn class="ma-2" outlined color="indigo" @click="goToStore"><v-icon>mdi-google-chrome</v-icon> {{ $t("common.chromeBtn") }}</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" md="4">
        <p class="title indigo-color">{{ $t("landing.cards.card1Title") }}</p>
        <v-card
          class="mx-auto"
          max-width="344"
        >
          <v-img
            src="https://firebasestorage.googleapis.com/v0/b/vuesaga-b8d1b.appspot.com/o/assets%2Fsaga-grab-widgets.png?alt=media&token=34955663-1228-4f82-a2c2-b584bf4a86c6"
            height="200px"
          ></v-img>

          <v-card-title>
            {{ $t("landing.cards.card1Head") }}
          </v-card-title>

          <v-card-text>
            {{ $t("landing.cards.card1Text") }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="12" md="4">
        <p class="title green-color">{{ $t("landing.cards.card2Title") }}</p>
        <v-card
          class="mx-auto"
          max-width="344"
        >
          <v-img
            src="https://firebasestorage.googleapis.com/v0/b/vuesaga-b8d1b.appspot.com/o/assets%2Fsaga-grab-edit-dialog.jpg?alt=media&token=9d320220-0657-4e1a-8213-e1960383fd84"
            height="200px"
          ></v-img>

          <v-card-title>
            {{ $t("landing.cards.card2Head") }}
          </v-card-title>

          <v-card-text>
            {{ $t("landing.cards.card2Text") }}
          </v-card-text>

        </v-card>
      </v-col>
      <v-col sm="12" md="4">
        <p class="title yellow-color">{{ $t("landing.cards.card3Title") }}</p>
        <v-card
          class="mx-auto"
          max-width="344"
        >
          <v-img
            src="https://firebasestorage.googleapis.com/v0/b/vuesaga-b8d1b.appspot.com/o/assets%2Fsaga-grab-clock-fr.png?alt=media&token=14a4eb36-370a-458f-9db9-67040d242ae2"
            height="200px"
          ></v-img>

          <v-card-title>
            {{ $t("landing.cards.card3Head") }}
          </v-card-title>

          <v-card-text>
            {{ $t("landing.cards.card3Text") }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col xs="12" class="padding-top">
        <h2 class="display-1" color="blue-grey darken-3">{{ $t("landing.pricing.title") }}</h2>
        <p class="body-1">{{ $t("landing.pricing.subtitle1") }}<br />{{ $t("landing.pricing.subtitle2") }}</p>
        <pricing-table />
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
// import PricingTable from './PricingTable'

export default {
  name: 'MainContent',
  components: {
    // PricingTable
  },
  methods: {
    goToStore() {
      window.open('https://chrome.google.com/webstore/detail/fepolifledkafebcdlcdfgpmahdjgdgn', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.main-container {
  background-color: white;
  position: relative;
  top: -40px;
  border-radius: 10px;
  .indigo-color {
    color: #3F51B5;
  }
  .green-color {
    color: #388E3C;
  }
  .yellow-color {
    color: #F57F17;
  }
}
.padding-top {
  padding-top: 60px;
}
.nobtn {
  cursor: default;
}
</style>